import ArrowBackButton from "../../../components/button/ArrowBackButton"
import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import useProjectForm from "./useProjectForm"
import { Checkbox } from "antd"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const ProjectForm = () => {
    const params = useParams()
    const [isUpdate, setIsUpdate] = useState(false)
    const {
        payload,
        onChangeHandler,
        postProjectForm,
        putProjectForm,
        getProjectForm,
        groupBu,
        getGroupBu,
        isSaving,
        // scoringMethod,
        // handleSelectScoringMethod
    } = useProjectForm()

    const callFunc = async(id) => {
        if (id) {
            setIsUpdate(true)
            await getProjectForm(id)
        }
        await getGroupBu()
    }

    useEffect(() => {
        callFunc(params.project_id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.project_id])

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton 
                    title={isUpdate ? "Edit Project" : "Create Project"} 
                    isTwoSection={true}
                />
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    {isUpdate ? "Edit Project Information" : "Project Information"}
                </h5>

                <form onSubmit={
                    isUpdate ?
                    (e) => putProjectForm(e) :
                    (e) => postProjectForm(e)
                }>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px', marginBottom: '24px' }}>
                            <div>
                                <label htmlFor="Name" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Project Name <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="text" 
                                    name="Name"
                                    className="form-control" 
                                    id="Name" 
                                    placeholder="Enter Project Name" 
                                    value={payload.Name}
                                    onChange={onChangeHandler}
                                    style={{
                                        padding: '8px 12px',
                                        borderRadius: '6px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px'
                                    }}
                                />
                            </div>

                            <div>
                                <label htmlFor="Year" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Project Year <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number" 
                                    name="Year"
                                    className="form-control" 
                                    id="Year" 
                                    placeholder="Year" 
                                    value={payload.Year}
                                    onChange={onChangeHandler}
                                    style={{
                                        padding: '8px 12px',
                                        borderRadius: '6px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px'
                                    }}
                                />
                            </div>
                        </div>

                        <div className={isUpdate ? "mb-4" : "mb-0"}>
                            <label style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '12px',
                                display: 'block'
                            }}>
                                Calibration Score Exceeds Quota <span style={{color: 'red'}}>*</span>
                            </label>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}>
                                    <Checkbox
                                        name="APlusExcess"
                                        onChange={onChangeHandler}
                                        checked={payload.APlusExcess}
                                        style={{ transform: 'scale(1.2)' }}
                                    />
                                    <span style={{ marginLeft: '8px' }}>A+</span>
                                </label>
                                
                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}>
                                    <Checkbox
                                        name="AExcess"
                                        onChange={onChangeHandler}
                                        checked={payload.AExcess}
                                        style={{ transform: 'scale(1.2)' }}
                                    />
                                    <span style={{ marginLeft: '8px' }}>A</span>
                                </label>

                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}>
                                    <Checkbox
                                        name="BPlusExcess"
                                        onChange={onChangeHandler}
                                        checked={payload.BPlusExcess}
                                        style={{ transform: 'scale(1.2)' }}
                                    />
                                    <span style={{ marginLeft: '8px' }}>B+</span>
                                </label>
                                
                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}>
                                    <Checkbox
                                        name="BExcess"
                                        onChange={onChangeHandler}
                                        checked={payload.BExcess}
                                        style={{ transform: 'scale(1.2)' }}
                                    />
                                    <span style={{ marginLeft: '8px' }}>B</span>
                                </label>
                                
                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}>
                                    <Checkbox
                                        name="CExcess"
                                        onChange={onChangeHandler}
                                        checked={payload.CExcess}
                                        style={{ transform: 'scale(1.2)' }}
                                    />
                                    <span style={{ marginLeft: '8px' }}>C</span>
                                </label>
                                
                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}>
                                    <Checkbox
                                        name="DExcess"
                                        onChange={onChangeHandler}
                                        checked={payload.DExcess}
                                        style={{ transform: 'scale(1.2)' }}
                                    />
                                    <span style={{ marginLeft: '8px' }}>D</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div style={{ 
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: '24px',
                     }}>
                        {isUpdate && groupBu?.map((gbu, index) => gbu.Status && (
                            <div key={index} style={{
                                padding: '20px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb',
                                marginBottom: '24px',
                                width: 'calc(50% - 12px)'
                            }}>
                                <label style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '16px',
                                    display: 'block'
                                }}>
                                    Score Distribution {gbu.GroupName} <span style={{color: 'red'}}>*</span>
                                </label>
                                {['APlus', 'A', 'BPlus', 'B', 'C', 'D'].map((grade) => {
                                    const gradeDisplay = grade === 'APlus' ? 'A+' : grade === 'BPlus' ? 'B+' : grade;
                                    return (
                                        <div key={grade} style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            marginBottom: '12px',
                                            gap: '12px',
                                            fontSize: '14px'
                                        }}>
                                            <label style={{
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                color: '#374151',
                                                minWidth: '30px'
                                            }}>
                                                {gradeDisplay}
                                            </label>
                                            <input 
                                                required
                                                step=".01"
                                                type="number" 
                                                name={`${gbu.GroupName}.${grade}LowerLimit`}
                                                className="form-control" 
                                                id={`${gbu.GroupName}.${grade}LowerLimit`}
                                                placeholder="Lower Limit"
                                                style={{
                                                    padding: '8px 12px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #d1d5db',
                                                    fontSize: '16px'
                                                }}
                                                value={payload[gbu.GroupName]?.[`${grade}LowerLimit`]}
                                                onChange={(e) => onChangeHandler(e)}
                                            />
                                            <input 
                                                required
                                                step=".01"
                                                type="number" 
                                                name={`${gbu.GroupName}.${grade}UpperLimit`}
                                                className="form-control" 
                                                id={`${gbu.GroupName}.${grade}UpperLimit`} 
                                                placeholder="Upper Limit" 
                                                style={{
                                                    padding: '8px 12px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #d1d5db',
                                                    fontSize: '16px'
                                                }}
                                                value={payload[gbu.GroupName]?.[`${grade}UpperLimit`]}
                                                onChange={(e) => onChangeHandler(e)}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        ))}
                    </div>
                    
                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            /> :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Project"}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ProjectForm